import { Outlet } from 'react-router-dom';
import DayPlanningOverview from './DayPlanningOverview';

const DayPlanningPage = () => {
  return (
    <>
      <DayPlanningOverview />
      <Outlet />
    </>
  );
};

export default DayPlanningPage;
